import React, { useState, useEffect } from 'react';
import {
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  Box,
  FormControl,
  InputLabel,
  Select,
  InputAdornment,
  MenuItem
} from '@mui/material';
  import LockIcon from '@mui/icons-material/Lock';
import axios, { getBranches } from '../../axios';

const AddManagerForm = ({ editManager, onSubmit }) => {
  const [confirmPassword, setConfirmPassword] = useState('');
  const [manager, setManager] = useState({
    name: '',
    email: '',
    contact: '',
    password: '',
  });
  const [adminOptions, setAdminOptions] = useState([]);
  const [admin, setAdmin] = useState(null);
  const [error, setError] = useState(''); // For form error handling

  useEffect(() => {
    fetchAdmins();
  }, []);
  //console.log(editManager)
//console.log(manager)
  useEffect(() => {
    if (editManager) {
      setManager({
        name: editManager.name || '',
        email: editManager.email || '',
        contact: editManager.contact || '',
        password: '', // Clear password field for editing
      });
      setAdmin(adminOptions.find(option => option.value === editManager.admin_id) || null);
    } else {
      
      clearForm(); // Clear form when no editManager
    }
  }, [editManager, adminOptions]);
  const fetchAdmins = async () => {
    try {
      const response = await getBranches()
      const branchOptions = response.data.map(branch => ({
        value: branch.id, // ID for backend
        label: branch.name, // Name for display
      }));
      setAdminOptions(branchOptions);
    } catch (error) {
      setError('Failed to fetch admins');
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setManager({ ...manager, [name]: value });
  };

  const clearForm = () => {
    setManager({
      name: '',
      email: '',
      contact: '',
      password: '',
    });
    setConfirmPassword('');
    setAdmin(null);
    setError('');
  };

  const validateForm = () => {
    if (!admin) {
      setError('Please select an admin');
      return false;
    }
    if (!editManager && manager.password !== confirmPassword) {
      setError('Passwords do not match');
      return false;
    }
    setError('');
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    const managerData = {
      ...manager,
      admin_id: admin, // Ensure admin_id is used for submission
      password: editManager ? undefined : manager.password, // Only include password if not editing
    };
    //console.log(managerData)
    try {
      await onSubmit(managerData); // Pass manager data to onSubmit function
      clearForm();
    } catch (error) {
      setError('Failed to submit form');
    }
  };

  return (
       <Container maxWidth="lg" sx={{ mt: 4 }}>
             <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
 
        <Typography  variant="h5" align="center" gutterBottom color="green">
          {editManager ? 'Edit Manager' : 'Add Manager'}
        </Typography>

<Box component="form" onSubmit={handleSubmit}>
        <TextField
          label="Manager Name"
          placeholder="Manager Name"
          name="name"
          value={manager.name}
          onChange={handleInputChange}
          required
          margin="normal"
          fullWidth
        />

        <TextField
          label="Email Id"
          placeholder="Email Id"
          name="email"
          value={manager.email}
          onChange={handleInputChange}
          required
          margin="normal"
          fullWidth
        />

        <TextField
          label="Mobile No"
          placeholder="Mobile No"
          name="contact"
          value={manager.contact}
          onChange={handleInputChange}
          required
          margin="normal"
          fullWidth
        />

 <FormControl fullWidth margin="normal">
        <InputLabel>Select Admin</InputLabel>
        <Select
          value={admin}
          label="Select Admin"
          onChange={(e) => setAdmin(e.target.value)}
          required
        >
          {adminOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

         <TextField
                          label="Password"
                          type="password"
                          name="password"
                          variant="outlined"
                          value={manager.password}
                          onChange={handleInputChange}
                          fullWidth
                          required
                          margin="normal"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <LockIcon color="action" />
                              </InputAdornment>
                            ),
                          }}
                        />

      {!editManager && (
        <div>
          <TextField
            label="Confirm Password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            fullWidth
            margin="normal"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockIcon color="action" />
                </InputAdornment>)}}
          />
        </div>
      )}

        <Button   
        type="submit"
            variant="contained"
            color="success"
            fullWidth
            sx={{ mt: 3, py: 1.5, fontWeight: 'bold' }}
            onClick={handleSubmit}
            >
          {editManager ? 'Update Manager' : 'Add Manager'}
        </Button>
      </Box>
    </Paper>
      </Container>
  );
};

export default AddManagerForm;
